/**
 * VATPAN Resources — datasheet / quality document search.
 */
(function () {
  'use strict';

  function initPanel(panel) {
    var search = panel.querySelector('[data-vatpan-resource-search]');
    var countEl = panel.querySelector('[data-vatpan-resource-count]');
    var noResults = panel.querySelector('[data-vatpan-no-results]');
    var cards = panel.querySelectorAll('[data-vatpan-resource-card]');
    if (!search || !cards.length) return;

    function update() {
      var q = String(search.value || '')
        .trim()
        .toLowerCase();
      var visible = 0;

      cards.forEach(function (card) {
        var title = (
          card.getAttribute('data-resource-title') ||
          card.textContent ||
          ''
        )
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
        var show = !q || title.indexOf(q) !== -1;
        card.hidden = !show;
        if (show) visible++;
      });

      if (countEl) {
        countEl.textContent = visible + ' / ' + cards.length;
      }
      if (noResults) {
        noResults.hidden = visible > 0;
      }
    }

    search.addEventListener('input', update);
    search.addEventListener('search', update);
    update();
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-resource-section]').forEach(initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
